import { render, staticRenderFns } from "./landing.vue?vue&type=template&id=7740987a&scoped=true"
import script from "./landing.vue?vue&type=script&lang=js"
export * from "./landing.vue?vue&type=script&lang=js"
import style0 from "./landing.vue?vue&type=style&index=0&id=7740987a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7740987a",
  null
  
)

export default component.exports